import { MultiColumnBlock, NestedBlockWithHeadline } from './MultiColumnBlock/MultiColumnBlock'

export const blockTypes = {
  'multi-column': MultiColumnBlock,
  'image-with-text': MultiColumnBlock,
  'icon-with-text': MultiColumnBlock,
  'video-with-text': MultiColumnBlock,

  // Legacy: The contactForm and productSlider blocks as defined in the block
  // templates previously were of type "headline-block". They were changed to
  // "multi-column" with the addition of optional block headlines (EPUI-2282).
  // Because some shops had added these blocks before the change (and have it
  // in the saved data structure as "headline-block"), we keep the legacy type
  // here for compatibility.
  'headline-block': MultiColumnBlock,

  // This is for the gmapsAndContactForm and contactFormAndText blocks as
  // defined in the block templates. They are of type "multi-column" but have a
  // nested block "nested-headline-block" inside the data structure.
  'nested-headline-block': NestedBlockWithHeadline,
}
